import React, { useContext } from 'react';
import styled from 'styled-components';
import { FlexSpace, card, LinkTab, LinksContainer } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const NEW_SUPPLIER_TABS = ['settings'];
const EXISTING_SUPPLIER_TABS = ['settings', 'orders'];
const EXISTING_SUPPLIER_TABS_WITH_BILLING = ['settings', 'financials', 'orders', 'rates'];

const Wrapper = styled(FlexSpace)`
  ${card};
  padding: 0 30px;
  z-index: 3;
`;

const Tabs = ({ editMode, activeTab, setActiveTab, allowClientBillingInfo = true, isClientControlsRates = false }) => {
  const { t } = useContext(ConfigContext);

  const baseTabs = editMode
    ? allowClientBillingInfo
      ? EXISTING_SUPPLIER_TABS_WITH_BILLING
      : EXISTING_SUPPLIER_TABS
    : NEW_SUPPLIER_TABS;

  const tabs = [...baseTabs, ...(isClientControlsRates ? ['positions-mapping'] : [])];

  return (
    <Wrapper>
      <LinksContainer>
        {(tabs || []).map((tab) => (
          <LinkTab key={tab} isActive={activeTab === tab} onClick={() => setActiveTab(tab)}>
            {t(tab)}
          </LinkTab>
        ))}
      </LinksContainer>

      {/* <PromptClick
        body={t('areYouSureDeleteSupplier')}
        confirmText="delete"
        onClick={() => deleteSupplier({ onSuccess: handleClose })}>
        <CircleIcon icon={DeleteIcon} tooltip={t('delete')} />
      </PromptClick> */}
    </Wrapper>
  );
};

export default Tabs;
